export { default } from './AddUserBlackListPopUp';



// WEBPACK FOOTER //
// ./src/components/UserBlackList/AddUserBlackListPopUp/index.js